const SERVER_URL = 
  "https://dr-vivek-kakkad-website-backend-nodejs-obwirxw2za-uw.a.run.app/"
  
  const IMAGE_URL = 
  "https://storage.googleapis.com/cdn-dr-vivek-kakkad-website/"
module.exports = {
  SERVER_URL,IMAGE_URL
};